import api from 'api';

export const MENU_ITEM_CATEGORIES_ASYNC_ACTION_START = 'MENU_ITEM_CATEGORIES_ASYNC_ACTION_START';
export const MENU_ITEM_CATEGORIES_ASYNC_ACTION_ERROR = 'MENU_ITEM_CATEGORIES_ASYNC_ACTION_ERROR';
export const MENU_ITEM_CATEGORIES_ASYNC_UPDATE_SUCCESS = 'MENU_ITEM_CATEGORIES_ASYNC_UPDATE_SUCCESS';
export const MENU_ITEM_CATEGORIES_RESET_STATE = 'MENU_ITEM_CATEGORIES_RESET_STATE';

function menuItemCategoriesAsyncActionStart() {
  return {
    type: MENU_ITEM_CATEGORIES_ASYNC_ACTION_START,
  };
}

function menuItemCategoriesAsyncActionError(error) {
  return {
    type: MENU_ITEM_CATEGORIES_ASYNC_ACTION_ERROR,
    error,
  };
}

function menuItemCategoriesAsyncUpdateSuccess(data) {
  return {
    type: MENU_ITEM_CATEGORIES_ASYNC_UPDATE_SUCCESS,
    data,
  };
}

export function resetMenuItemCategoriesState() {
  return {
    type: MENU_ITEM_CATEGORIES_RESET_STATE,
  };
}

export function getMenuItemCategoriesAsync() {
  return (dispatch, getState) => {
    dispatch(menuItemCategoriesAsyncActionStart());
    return api.request('menuItemCategory/list', 'get')
    .then((data) => {
      dispatch(menuItemCategoriesAsyncUpdateSuccess(data.subCategory));
      return data.subCategory;
    })
    .catch((err) => {
      dispatch(menuItemCategoriesAsyncActionError('Unable to get Menu Item Categories'));
      throw (err);
    });
  };
}
